import { useDeleteAlert } from '@equifinance/shared';
import { Applicant, useAccountContext } from '../../../contexts';

export default function useDeleteApplicant() {
  const { deleteFromAccountArray } = useAccountContext();
  const deleteAlert = useDeleteAlert();

  return (applicant: Applicant, applicantIndex: number) => {
    deleteAlert({
      onConfirm: () => deleteFromAccountArray('applicants', applicant?.id),
      text: `Are you sure you want to delete Applicant ${applicantIndex + 1}?`,
      content: 'All information related to that individual will be deleted. Some information regarding the other Applicant will also be lost.',
    });
  };
}
